(function () {
  'use strict';

  var SIGN_KEYS = ['aries', 'taurus', 'gemini', 'cancer', 'leo', 'virgo', 'libra', 'scorpio', 'sagittarius', 'capricorn', 'aquarius', 'pisces'];
  var PERIOD_PATHS = {
    '/pages/horoscope-daily': 'daily',
    '/pages/horoscope-weekly': 'weekly',
    '/pages/horoscope-monthly': 'monthly'
  };
  /* The section's "period word" (day/week/month/year…) is for display; the API
     wants the canonical period (daily/weekly/monthly/yearly/half-yearly). Map
     between them so every horoscope page fetches the right reading. */
  var WORD_TO_PERIOD = {
    day: 'daily', daily: 'daily',
    week: 'weekly', weekly: 'weekly',
    month: 'monthly', monthly: 'monthly',
    year: 'yearly', yearly: 'yearly',
    'half-year': 'half-yearly', 'half-yearly': 'half-yearly', 'halfyearly': 'half-yearly'
  };
  function normPeriod(v) { v = String(v || '').trim().toLowerCase(); return WORD_TO_PERIOD[v] || v; }

  function pathPeriod() {
    var path = window.location.pathname.replace(/\/$/, '');
    return PERIOD_PATHS[path] || '';
  }

  function safeUrl(value) {
    try {
      var url = new URL(value, window.location.origin);
      return url.protocol === 'https:' ? url.href : '';
    } catch (error) { return ''; }
  }

  function editorialText(value) {
    return String(value || '').split(/(?<=[.!?])\s+/).filter(function (sentence) {
      return !/\b(?:health\w*|pregnan\w*|heal(?:ing|er|ers|ed|s)?|medical|medicin\w*|disease\w*|illness\w*|fertility|infertility|therap\w*|cure[sd]?|wellbeing|well-being|wellness|progeny|conceiv\w*|conception|diagnos\w*|treatment|symptoms?|digestion|kidneys?|blood pressure|pain|insomnia|depression|anxiety)\b/i.test(sentence);
    }).join(' ').trim();
  }
  function setText(element, value) {
    if (!element || typeof value !== 'string' || !value.trim()) return;
    element.textContent = editorialText(value);
  }

  function applyArticle(panel, article) {
    if (!panel || !article) return;
    setText(panel.querySelector('[data-hs-title]'), article.title);
    setText(panel.querySelector('[data-hs-overview]'), article.overview);
    setText(panel.querySelector('[data-hs-summary]'), article.overview);

    if (article.video && /^[A-Za-z0-9_-]{11}$/.test(article.video.id) && panel.querySelector('.hs-sign-article__body')) {
      var body = panel.querySelector('.hs-sign-article__body');
      if (!body.querySelector('[data-hs-video]')) {
        var frame = document.createElement('iframe'); frame.dataset.hsVideo = 'true'; frame.title = article.title;
        frame.src = 'https://www.youtube-nocookie.com/embed/' + article.video.id; frame.loading = 'lazy'; frame.allowFullscreen = true;
        frame.style.cssText = 'width:100%;aspect-ratio:16/9;border:0;border-radius:16px;margin-top:24px'; body.appendChild(frame);
      }
    }
    var updated = panel.querySelector('[data-hs-updated]');
    if (updated && article.periodLabel) {
      updated.textContent = article.periodLabel;
      updated.hidden = false;
    }

    var root = panel.closest('[data-hs-read]');
    var heroDate = root && root.querySelector('[data-hs-hero-date]');
    if (heroDate && article.periodLabel) heroDate.textContent = article.periodLabel;

    /* Replace the concerns supplied by the current feed. Any concern the
       source does not provide keeps its reviewed Shopify copy. */
    (article.sections || []).forEach(function (entry) {
      if (entry.key === 'health' || !editorialText(entry.text)) return;
      var section = panel.querySelector('[data-hs-live-section="' + entry.key + '"]');
      if (!section) return;
      var heading = entry.heading;
      if (entry.key === 'career' && /\b(money|income|spending|financial)\b/i.test(String(entry.text).slice(0, 180))) {
        heading = 'Career, Work & Money';
      }
      setText(section.querySelector('[data-hs-live-heading]'), heading);
      setText(section.querySelector('[data-hs-live-text]'), entry.text);
      section.hidden = false;
    });

    var source = panel.querySelector('[data-hs-source]');
    var sourceLink = panel.querySelector('[data-hs-source-link]');
    var sourceUrl = article.source && safeUrl(article.source.url);
    if (source && sourceLink && sourceUrl) {
      sourceLink.href = sourceUrl;
      sourceLink.textContent = article.source.label || 'Powered by Sigastra';
      sourceLink.rel = 'noopener';
      source.hidden = false;
    }

    var status = panel.querySelector('[data-hs-status]');
    if (status) status.hidden = true;
    panel.classList.add('is-live');
  }

  function hydrate(panel, api, period) {
    if (!panel || panel.dataset.hydrated === 'true') return;
    var key = panel.getAttribute('data-hs-panel');
    if (SIGN_KEYS.indexOf(key) === -1) return;
    panel.dataset.hydrated = 'true';

    fetch(api + '?period=' + encodeURIComponent(period) + '&sign=' + encodeURIComponent(key), {
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Request failed');
        return response.json();
      })
      .then(function (payload) {
        if (!payload || !payload.ok || !payload.article) throw new Error('No article');
        applyArticle(panel, payload.article);
      })
      .catch(function () {
        /* The server-rendered Shopify article remains readable on failure. */
        panel.classList.add('is-reviewed-fallback');
      });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-hs-read]').forEach(function (root) {
      if (root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';

      var period = pathPeriod() || normPeriod(root.getAttribute('data-period'));
      var api = safeUrl(root.getAttribute('data-api'));
      var liveEnabled = root.getAttribute('data-live-updates') !== 'false' && !!period && !!api;
      if (!liveEnabled) return;

      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-hs-panel]'));
      if (!panels.length) return;

      // Load every sign's reading up front so all 12 show real, distinct content
      // immediately — no lazy "fills in as you scroll", and no identical fallback
      // text lingering on the signs further down the page. Twelve small cached
      // requests are cheap and run in parallel.
      panels.forEach(function (panel) { hydrate(panel, api, period); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
